import { render, staticRenderFns } from "./SumaryCard.vue?vue&type=template&id=6c2d4be9&scoped=true&"
import script from "./SumaryCard.vue?vue&type=script&lang=js&"
export * from "./SumaryCard.vue?vue&type=script&lang=js&"
import style0 from "./SumaryCard.vue?vue&type=style&index=0&id=6c2d4be9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2d4be9",
  null
  
)

export default component.exports